<template>
  <div class="d-flex align-center" style="margin-left: 2em">
    <span
        :style="systemLocale === 'ru'
          ? styleActive
          : styleInactive"
        @click="changeLocale('ru')">
      Рус
    </span>
    <span style="margin: 0 12px">
      |
    </span>
    <span
        :style="systemLocale === 'en'
          ? styleActive
          : styleInactive"
        @click="changeLocale('en')">
      Eng
    </span>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { LOCALIZATION } from '@/constants/store.js'
  export default {
    data () {
      return {
        styleActive: {
          cursor: 'default',
          fontWeight: 'bold'
        },
        styleInactive: {
          cursor: 'pointer',
          color: 'lightgrey'
        }
      }
    },
    methods: {
      ...mapActions(LOCALIZATION.NAMESPACE, {
        setLocaleAction: LOCALIZATION.ACTIONS.SET_LOCALE
      }),
      changeLocale: async function (locale) {
        this.$router.replace({
          name: this.$route.name,
          params: {
            ...this.$route.params,
            lang: locale
          }
        })
        // изменение в localStorage
        await this.setLocaleAction(locale)
      }
    }
  }
</script>
